/* Zakumi theme — vanilla JS for cart, mobile nav, product page */
(function () {
  'use strict';

  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => Array.from(el.querySelectorAll(sel));
  const routes = (window.theme && window.theme.routes) || {};
  const strings = (window.theme && window.theme.strings) || {};

  /* ---------------- Mobile menu ---------------- */
  const menuBtn = $('[data-zk-menu-toggle]');
  const mobileNav = $('[data-zk-mobile-nav]');
  if (menuBtn && mobileNav) {
    const setMenu = (open) => {
      if (open) {
        mobileNav.removeAttribute('hidden');
        $('[data-zk-menu-icon-open]').setAttribute('hidden', '');
        $('[data-zk-menu-icon-close]').removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      } else {
        mobileNav.setAttribute('hidden', '');
        $('[data-zk-menu-icon-open]').removeAttribute('hidden');
        $('[data-zk-menu-icon-close]').setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
      menuBtn.setAttribute('aria-expanded', String(open));
    };
    menuBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      setMenu(mobileNav.hasAttribute('hidden'));
    });
    // Close on any nav link click
    mobileNav.addEventListener('click', (e) => {
      if (e.target.closest('a')) setMenu(false);
    });
    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !mobileNav.hasAttribute('hidden')) setMenu(false);
    });
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (mobileNav.hasAttribute('hidden')) return;
      if (!mobileNav.contains(e.target) && !menuBtn.contains(e.target)) setMenu(false);
    });
    // Close when resizing to desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768 && !mobileNav.hasAttribute('hidden')) setMenu(false);
    });
  }

  /* ---------------- Toast ---------------- */
  function toast(title, desc) {
    const el = $('#zk-toast');
    if (!el) return;
    $('.zk-toast__title', el).textContent = title || strings.addedToBag;
    $('.zk-toast__desc', el).textContent = desc || '';
    el.removeAttribute('hidden');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => el.setAttribute('hidden', ''), 2400);
  }

  /* ---------------- Cart drawer ---------------- */
  const cartRoot = $('[data-zk-cart-root]');
  const cartItems = $('[data-zk-cart-items]');
  const cartEmpty = $('[data-zk-cart-empty]');
  const cartFoot = $('[data-zk-cart-foot]');
  const cartCountBadge = $('[data-zk-cart-count]');
  const cartTotalEl = $('[data-zk-cart-total]');
  const cartSub = $('[data-zk-cart-sub]');
  const itemTpl = $('#zk-cart-item-template');

  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || 'R {{amount}}';
    const n = (cents || 0) / 100;
    const withDelims = (num, dec, th, d) => { const [i, f] = num.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? d + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withDelims(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withDelims(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(n, 0, '.', ',');
      if (k === 'amount_with_space_separator') return withDelims(n, 2, ' ', ',');
      return withDelims(n, 2, ',', '.');
    });
  }

  function openCart() {
    if (!cartRoot) return;
    cartRoot.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartRoot) return;
    cartRoot.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
  $$('[data-zk-cart-open]').forEach(b => b.addEventListener('click', openCart));
  $$('[data-zk-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  async function getCart() {
    const r = await fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  function renderCart(cart) {
    const count = cart.item_count;
    if (cartCountBadge) {
      if (count > 0) {
        cartCountBadge.textContent = count;
        cartCountBadge.removeAttribute('hidden');
      } else {
        cartCountBadge.setAttribute('hidden', '');
      }
    }
    if (!cartItems || !cartEmpty || !cartFoot) return;
    if (count === 0) {
      cartEmpty.removeAttribute('hidden');
      cartItems.setAttribute('hidden', '');
      cartFoot.setAttribute('hidden', '');
      if (cartSub) cartSub.textContent = 'Empty for now.';
      return;
    }
    cartEmpty.setAttribute('hidden', '');
    cartItems.removeAttribute('hidden');
    cartFoot.removeAttribute('hidden');
    if (cartSub) cartSub.textContent = `${count} item${count !== 1 ? 's' : ''} reserved.`;
    cartItems.innerHTML = '';
    cart.items.forEach(item => {
      const node = itemTpl.content.firstElementChild.cloneNode(true);
      const img = $('img', node);
      img.src = item.image || '';
      img.alt = item.product_title;
      $('.zk-cart-item__title', node).textContent = item.product_title;
      $('.zk-cart-item__opts', node).textContent = (item.options_with_values || []).map(o => o.value).join(' · ');
      $('.zk-cart-item__price', node).textContent = formatMoney(item.final_price);
      $('[data-zk-cart-qty]', node).textContent = item.quantity;
      $('[data-zk-cart-inc]', node).addEventListener('click', () => changeQty(item.key, item.quantity + 1));
      $('[data-zk-cart-dec]', node).addEventListener('click', () => changeQty(item.key, Math.max(0, item.quantity - 1)));
      $('[data-zk-cart-remove]', node).addEventListener('click', () => changeQty(item.key, 0));
      cartItems.appendChild(node);
    });
    if (cartTotalEl) cartTotalEl.textContent = formatMoney(cart.total_price);
  }

  async function refreshCart() {
    try { renderCart(await getCart()); } catch (e) { console.error(e); }
  }

  async function changeQty(key, quantity) {
    try {
      const r = await fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await r.json();
      renderCart(cart);
    } catch (e) { console.error(e); }
  }

  async function addToCart(variantId, quantity) {
    const r = await fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    });
    if (!r.ok) throw new Error('Add failed');
    return r.json();
  }

  /* Quick-add buttons on product cards */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-zk-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.dataset.variantId;
    const title = btn.dataset.productTitle;
    btn.disabled = true;
    btn.textContent = '…';
    try {
      await addToCart(id, 1);
      toast(strings.addedToBag, title);
      await refreshCart();
      openCart();
    } catch (err) {
      btn.textContent = 'Try again';
    } finally {
      btn.disabled = false;
      btn.textContent = strings.quickAdd;
    }
  });

  /* Initial cart fetch for the badge */
  refreshCart();

  /* ---------------- Product page ---------------- */
  const productForm = $('[data-zk-pdp-form]');
  if (productForm) {
    const productJsonEl = $('[data-zk-product-json]');
    const product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    const variantSelect = $('[data-zk-variant-select]', productForm);
    const priceEl = $('[data-zk-price]');
    const addBtn = $('[data-zk-add-btn]', productForm);

    function selectedOptions() {
      return $$('input[name^="options"]', productForm).filter(i => i.checked).map(i => i.value);
    }
    function findVariant() {
      if (!product) return null;
      const opts = selectedOptions();
      return product.variants.find(v => v.options.every((o, i) => o === opts[i])) || null;
    }
    function updateVariant() {
      const v = findVariant();
      if (!v) return;
      variantSelect.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? strings.addToBag + ' · ' + formatMoney(v.price) : strings.soldOut;
      }
      const sp = $('.zk-sticky-atc__price'); if (sp) sp.textContent = formatMoney(v.price);
      if (v.featured_image) { const m = $('#zk-pdp-main-img'); if (m) m.src = v.featured_image.src; }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    productForm.addEventListener('change', (e) => {
      if (e.target.matches('input[name^="options"]')) {
        updateVariant();
      }
    });
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const v = findVariant();
      if (!v || !v.available) return;
      addBtn.disabled = true;
      addBtn.textContent = '…';
      try {
        await addToCart(v.id, 1);
        toast(strings.addedToBag, product.title);
        await refreshCart();
        openCart();
        addBtn.textContent = strings.addToBag + ' · ' + formatMoney(v.price);
      } catch (err) {
        addBtn.textContent = 'Try again';
      } finally {
        addBtn.disabled = !v.available;
      }
    });

    /* Thumbnail switching */
    const mainImg = $('#zk-main-img');
    $$('[data-zk-thumb]').forEach(t => t.addEventListener('click', () => {
      $$('[data-zk-thumb]').forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
      if (mainImg) mainImg.src = t.dataset.src;
    }));
  }

  /* ---------------- Scroll reveal (cheap fallback for fade-in) ---------------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.style.animationPlayState = 'running'; io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -50px 0px' });
    /* No-op if already animated; this is just a guard for future use */
  }
})();

/* ============ V2 — Reveal on scroll + Sticky ATC + PDP main img id ============ */
(function () {
  if (!('IntersectionObserver' in window)) return;
  const reveals = document.querySelectorAll('.zk-reveal');
  if (reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });
    reveals.forEach(el => io.observe(el));
  }

  /* PDP thumb -> main image (new id) */
  const main = document.getElementById('zk-pdp-main-img');
  if (main) {
    document.querySelectorAll('[data-zk-thumb]').forEach(t => {
      t.addEventListener('click', () => {
        document.querySelectorAll('[data-zk-thumb]').forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
        main.src = t.dataset.src;
      });
    });
  }

  /* Sticky ATC — show after the main ATC scrolls out of view */
  const sticky = document.querySelector('[data-zk-sticky-atc]');
  const form = document.querySelector('[data-zk-pdp-form]');
  const mainBtn = document.querySelector('[data-zk-add-btn]');
  if (sticky && form && mainBtn) {
    sticky.hidden = false;
    const stickyBtn = sticky.querySelector('[data-zk-sticky-add]');
    stickyBtn && stickyBtn.addEventListener('click', () => mainBtn.click());
    const watch = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) sticky.classList.remove('is-visible');
        else sticky.classList.add('is-visible');
      });
    }, { rootMargin: '-100px 0px 0px 0px' });
    watch.observe(mainBtn);
  }
})();

/* Theme editor: reload page scripts when sections change so everything stays interactive */
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.zk-reveal').forEach(el => el.classList.add('is-visible'));
  });
}
